import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

export default function PasswordComp({
  newPassword,
  newPassword2,
  setNewPassword,
  setNewPassword2,
  resetReason,
  // resetPasswordAPI,
  // changePasswordAPI,
  updatePasswordAPI,
  pwdClientMsg,
  setPwdClientMsg,
}) {
  const navigate = useNavigate()

  useEffect(() => {
    setPwdClientMsg(pwdClientMsg)
  }, [pwdClientMsg])
  const resetPassword = (e) => {
    e.preventDefault()
    let errMsg = ' '
    let ruleCount = 0
    if (newPassword != newPassword2) {
      errMsg = '비밀번호가 일치하지 않습니다.'
    } else {
      const uppercaseRegExp = /(?=.*?[A-Z])/
      const lowercaseRegExp = /(?=.*?[a-z])/
      const digitsRegExp = /(?=.*?[0-9])/
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/
      const min1LengthRegExp = /.{8,}/
      const min2LengthRegExp = /.{10,}/
      const passwordLength = newPassword.length
      const uppercasePassword = uppercaseRegExp.test(newPassword)
      const lowercasePassword = lowercaseRegExp.test(newPassword)
      const digitsPassword = digitsRegExp.test(newPassword)
      const specialCharPassword = specialCharRegExp.test(newPassword)
      const min1LengthPassword = min1LengthRegExp.test(newPassword)
      const min2LengthPassword = min2LengthRegExp.test(newPassword)

      if (passwordLength === 0) {
        errMsg = '비밀번호를 입력해주세요.'
      }
      if (uppercasePassword) {
        ruleCount++
      }
      if (lowercasePassword) {
        ruleCount++
      }
      if (digitsPassword) {
        ruleCount++
      }
      if (specialCharPassword) {
        ruleCount++
      }

      if (
        (ruleCount > 2 && min1LengthPassword) ||
        (ruleCount == 2 && min2LengthPassword)
      ) {
        errMsg = ''
      } else {
        errMsg = '비밀번호 설정이 올바르지 않습니다.'
      }
    }
    setPwdClientMsg(errMsg)

    if (errMsg == '') {
      updatePasswordAPI()
      // changePasswordAPI()
    }
  }
  return (
    <>
      <Input
        type="password"
        placeholder="새 비밀번호"
        onChange={(e) => setNewPassword(e.target.value)}
      />
      <Input
        type="password"
        placeholder="새 비밀번호 확인"
        onChange={(e) => setNewPassword2(e.target.value)}
      />
      <PwdRulesTxt>
        *영문 대/소,숫자,특수문자 중 2조합/10자 이상, 또는 3조합 8자 이상으로
        설정
      </PwdRulesTxt>
      <ClientMsgWrapper>{pwdClientMsg}</ClientMsgWrapper>
      {resetReason == undefined ? (
        <Wrapper>
          <CancelBttn onClick={() => navigate('/signin')}>취소</CancelBttn>
          <Button onClick={(e) => resetPassword(e)}>확인</Button>
        </Wrapper>
      ) : (
        <Wrapper>
          <CancelBttn onClick={() => navigate('/signin')}>취소</CancelBttn>
          <Button onClick={(e) => resetPassword(e)}>확인</Button>
        </Wrapper>
        // <SubmitButton onClick={(e) => resetPassword(e)}>확인</SubmitButton>
      )}
    </>
  )
}

// const SubmitButton = styled.div`
//   width: 100%;
//   height: 50px;
//   cursor: pointer;
//   border-radius: 8px;
//   background-color: #00a61c;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   font-size: 16px;
//   font-weight: bold;
//   text-align: center;
//   color: #fff;
//   position: absolute;
//   bottom: 10%;
//   @media ${(props) => props.theme.tablet} {
//   }
//   @media ${(props) => props.theme.mobile} {
//     width: 300px;
//     margin: auto;
//     position: relative;
//     bottom: auto;
//   }
// `

const Input = styled.input`
  font-size: 14px;
  text-align: left;
  color: #a8a8a8;
  width: 360px;
  height: 50px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  color: #8a8a8a;
  box-shadow: none !important;
  padding: 10px;
  margin-bottom: 10px;
  &:focus {
    outline: none !important;
  }
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 16px;
  font-weight: bold;
  justify-content: space-around;
  position: absolute;
  bottom: 10%;
  width: 100%;
  @media ${(props) => props.theme.mobile} {
  }
`

const CancelBttn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 174px;
  height: 50px;
  /* padding: 13px 72px; */
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  color: #04402e;
  cursor: pointer;
  @media ${(props) => props.theme.mobile} {
    width: 147px;
    /* padding: 13px 57px 13px 60px; */
  }
`

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 174px;
  /* padding: 13px 72px; */
  border-radius: 8px;
  background-color: #00a61c;
  color: #fff;
  cursor: pointer;

  @media ${(props) => props.theme.mobile} {
    width: 147px;
    /* padding: 13px 57px 13px 60px; */
  }
`
const PwdRulesTxt = styled.div`
  font-size: 14px;
  text-align: left;
  color: #8a8a8a;
  width: 360px;
  margin: auto;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
  }
`
const ClientMsgWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  text-align: left;
  color: #d90000;
  padding: 10px 0px 0px;
  width: 360px;
  margin: auto;
  @media ${(props) => props.theme.mobile} {
    width: 300px;
    padding: 10px 0px 10px;
  }
`
